import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute: React.FC = () => {
  const { isAuthenticated, loading } = useAuth();
  
  // Loading state - don't redirect until we've checked authentication
  if (loading) {
    return <div>Loading...</div>;
  }
  
  if (!isAuthenticated) {
    // Redirect to the login page
    return <Navigate to="/auth" />;
  }
  
  return <Outlet />;
};

export default ProtectedRoute;
